import Cookies from "universal-cookie"

export default function logout() {
    const cookies = new Cookies()

    cookies.remove("token", { path: "/" })
    cookies.remove("refresh_token", { path: "/" })
    window.location.replace("/login")
}
